import axiosInstance from "../axios-instance";
import { SpreadsheetsResponse } from "./types";

export const getWorksheets = async (
  workbookId: string,
): Promise<SpreadsheetsResponse> => {
  try {
    const response = await axiosInstance.get(
      `/v1/spreadsheets/${workbookId}/sheets`,
    );
    return response.data;
  } catch (error) {
    return {
      spreadsheets: [],
    };
  }
};
